import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const deleteSimType = async (typeId: string): Promise<boolean> =>
  axios.delete(`/management/simtype/RemoveSimType?typeId=${typeId}`).then((res) => res?.data?.result)

type Props = {
  typeId: string
}

export const useManagementDeleteSimType = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['deleteSimType'],
    mutationFn: ({ typeId }: Props) => deleteSimType(typeId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Deleted sim type.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to delete sim type, please try again.')
      }
    },
    throwOnError: false
  })
